import { useTranslation } from 'react-i18next';
import { SampleDetailsDto } from '@src/types/types.ts';
import { getEffectiveRegulation } from '@src/asbestos/utils.ts';
import { Card } from '@components/atoms/Card.tsx';
import { RegulationsUpselling } from '@components/sample-details/RegulationsUpselling.tsx';
import { AsbestosTargetType } from '@src/asbestos/types.ts';

type UpsellingProps = {
  sample: SampleDetailsDto;
};

export const AsbestosUpselling = ({ sample }: UpsellingProps) => {
  return <AnyUpselling sample={sample} titleKeyPostfix={'asbestosTitle'} />;
};

export const KmfUpselling = ({ sample }: UpsellingProps) => {
  return <AnyUpselling sample={sample} titleKeyPostfix={'kmfTitle'} />;
};

type AnyUpsellingProps = {
  sample: SampleDetailsDto;
  titleKeyPostfix: 'asbestosTitle' | 'kmfTitle';
};

const AnyUpselling = ({ sample, titleKeyPostfix }: AnyUpsellingProps) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterList' });
  const { t: tAsb } = useTranslation('component', {
    keyPrefix: 'parameterList.asbestosDetection',
  });
  const targetType =
    titleKeyPostfix === 'asbestosTitle'
      ? AsbestosTargetType.ASB
      : titleKeyPostfix === 'kmfTitle'
        ? AsbestosTargetType.KMF
        : undefined;

  if (!targetType) {
    return null;
  }

  const effectiveRegulation = getEffectiveRegulation(sample, targetType);

  const upsellingItems =
    effectiveRegulation === null || effectiveRegulation.length === 0
      ? []
      : (effectiveRegulation[0]?.upselling?.flatMap((up) => up) ?? []);

  return (
    <>
      {upsellingItems.length > 0 && (
        <Card>
          <RegulationsUpselling
            title={`${t('recommendations')} (${tAsb(titleKeyPostfix)})`}
            upsellingItems={upsellingItems}
          />
        </Card>
      )}
    </>
  );
};
